"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BlankPage = function BlankPage() {
  return /*#__PURE__*/_react["default"].createElement("div", null);
};

var _default = BlankPage;
exports["default"] = _default;